import XLSX from 'xlsx';
export default class Excel{
  constructor(self, event, callback) {
    this.handleExcelFile(self, event, callback)
  }
  getExcelHeadTitle(sheetData){
    let re = /^[A-Z]1$/; // 匹配excel第一行的内容
    let titles = [];
    for (let key in sheetData) { // excel第一行内容赋值给数组
      if (sheetData.hasOwnProperty(key)) {
        if (re.test(key)) {
          titles.push(sheetData[key].w);
        }
      }
    }
    return titles;
  }
  handleExcelFile(self,ev,cb)
  {
    const files = ev.target.files
    if (files.length < 1) {
      return false
    } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
      self.$Message.error('上传文件格式不正确，请上传xls或者xlsx格式')
      return false
    }
    const fileReader = new FileReader()
    fileReader.onload = (ev) => {
      try {
        const data = ev.target.result
        const workbook = XLSX.read(data, {
          type: 'binary'
        }) // 读取数据
        // 获取第一张表数据
        let sheetData = workbook.Sheets[workbook.SheetNames[0]];
        let titles = this.getExcelHeadTitle(sheetData);
        const sheetJSData = XLSX.utils.sheet_to_json(sheetData); // 生成json表格内容
        // let newArray = this.dateTransition(sheetJSData);
        // const ws1 = XLSX.utils.sheet_to_slk(workbook.Sheets[wsname]) // 输出表格对应位置是什么值
        // const ws2 = XLSX.utils.sheet_to_html(workbook.Sheets[wsname]) // 生成HTML输出
        // const ws3 = XLSX.utils.sheet_to_csv(workbook.Sheets[wsname]) // 生成分隔符分隔值输出
        // const ws4 = XLSX.utils.sheet_to_formulae(workbook.Sheets[wsname]) // 生成公式列表（具有值回退）
        // const ws5 = XLSX.utils.sheet_to_txt(workbook.Sheets[wsname]) // 生成UTF16格式的文本
        cb(titles, sheetJSData);
      } catch (e) {
        console.log(e)
        return false
      }
    }
    fileReader.readAsBinaryString(files[0])
  }
  // 将对应的中文key转化为自己想要的英文key
  dateTransition(data, CN2EngKeys){
    let res = [];
    data.forEach(obj=> {
      let objItem = {};
      Object.keys(obj).forEach(key=>{
        objItem[CN2EngKeys[key]] = obj[key];
      })
      res.push(objItem)
    })
    return res;
  }
}
